<template>
    <div>
        <app-header></app-header>
        <section class="categories-section spad">
            <div class="container">
                <div class="section-title">
                <h2>Видео</h2>
                </div>
                <div class="row">
                    <!-- products -->
                    <div v-for="(item, index) in PRODUCTS.data" :key="index" class="col-lg-4 col-md-6">
                        <div class="categorie-item">
                            <div @click="open(item.id)" style="cursor: pointer;" class="ci-thumbz set-bg">
                                <img src="@/assets/1035667.jpg" alt="">
                            </div>
                            <div class="ci-text">
                                <h5>{{item.name}}</h5>
                                <p>{{item.description.slice(0, 50)}} <span v-if="item.description.length > 50">...</span></p>
                            </div>
                        </div>
                    </div>
                    <!-- products -->
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import AppHeader from '@/components/header/'
    export default {
        props: {
            id: {
                type: String,
                default: '1',
                required: true
            },
        },
        methods: {
            open(id) {
                this.$store.dispatch('GET_SHOW', [
                    { name: 'products' },
                    { id: id}
                ])
                setTimeout(() => {
                    this.$router.push({name: 'video-show', params: {id: id.toString()}});
                }, 500);
            }
        },
        computed: {
            ...mapGetters([
                'PRODUCTS'
            ])
        },
        components: {
            AppHeader
        },
        created () {
            this.$store.dispatch('GET', [
                { 'cats[0]': this.id },
                { name: 'products' }
            ]);
        },
    }
</script>

<style scoped>
    .header-section{
        background: #3A3B40;
    }
    .ci-thumbz{
        /* background: url('.../1035667.jpg'); */
    }
</style>